import { TagColor } from '../../../../subcomponents/tag/types/color';
import { didLastSubscriptionPaymentFail, hasSubscriptionBeenCancelled, isSubscriptionExpiringSoon, isSubscriptionFrozen, isSubscriptionOnHold } from './status-utils';
export const getMemberSubscriptionTags = (subscription, isFuture, displayText, config) => {
    const tags = [];
    if (isFuture)
        return tags;
    if (isSubscriptionOnHold(subscription)) {
        tags.push({ label: displayText.onHoldTagLabel, color: TagColor.Warning });
    }
    if (isSubscriptionExpiringSoon(subscription, config.expiringSoonThresholdInMonths)) {
        tags.push({ label: displayText.expiringSoonTagLabel, color: TagColor.Warning });
    }
    if (isSubscriptionFrozen(subscription) || didLastSubscriptionPaymentFail(subscription)) {
        tags.push({ label: displayText.paymentFailedTagLabel, color: TagColor.Error });
    }
    if (hasSubscriptionBeenCancelled(subscription)) {
        tags.push({ label: displayText.cancelledTagLabel, color: TagColor.Error });
    }
    return tags;
};
